import React, { Suspense, lazy } from 'react';

const EducationScreen = lazy(() => import('./educationScreen.jsx'));

export const EducationScreenLazy = () => {
    return (
        <Suspense fallback={<div>loading...</div>}>
            <EducationScreen />
        </Suspense>
    );
};
